import { Badge, Box, Text, VStack } from '@chakra-ui/react'
import { FieldMapValue, RemoteAssessmentData } from '@hb/shared'

const FIELD_LABELS: Record<keyof RemoteAssessmentData, string> = {
  generalAppearance: 'General Appearance (Video)',
  patientReportedBp: 'Patient-Reported BP',
  patientReportedWeight: 'Patient-Reported Weight',
  patientReportedTemp: 'Patient-Reported Temperature',
  patientReportedO2Sat: 'Patient-Reported O2 Saturation',
  fetalMovement: 'Fetal Movement',
  breathingRespiratoryEffort: 'Breathing / Respiratory Effort',
  affectAndMood: 'Affect and Mood',
  chiefComplaintDetails: 'Chief Complaint Details',
}

const FIELD_ORDER: (keyof RemoteAssessmentData)[] = [
  'generalAppearance',
  'patientReportedBp',
  'patientReportedWeight',
  'patientReportedTemp',
  'patientReportedO2Sat',
  'fetalMovement',
  'breathingRespiratoryEffort',
  'affectAndMood',
  'chiefComplaintDetails',
]

// §2.1 Non-Routine + Telehealth: read-only view of the Remote Assessment section.
export const RemoteAssessmentView = ({ data }: { data: FieldMapValue }) => {
  const ra = data?.remoteAssessment as RemoteAssessmentData | undefined
  const hasAnyValue = ra && FIELD_ORDER.some(k => ra[k])

  return (
    <Box w="100%">
      <Badge colorScheme="blue" fontSize="xs" mb={3}>
        Patient self-reported — not provider-measured
      </Badge>
      {hasAnyValue ? (
        <VStack align="stretch" spacing={3}>
          {FIELD_ORDER.map(key => {
            const val = ra?.[key]
            if (!val) return null
            return (
              <Box key={key}>
                <Text fontSize="xs" fontWeight={600} color="gray.500" mb={0.5}>
                  {FIELD_LABELS[key]}
                </Text>
                <Text fontSize="sm" whiteSpace="pre-wrap">
                  {val}
                </Text>
              </Box>
            )
          })}
        </VStack>
      ) : (
        <Text fontSize="sm" fontStyle="italic" color="gray.400">
          No remote assessment findings documented.
        </Text>
      )}
    </Box>
  )
}
